import { useEffect, useState } from 'react';
import { AdminHeaderButtonView } from '@vivli/shared/views';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { DTISetTrackingButton } from '@vivli/shared/infrastructure/constants';
import { useDataRequestsApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';

export const SetTrackingButtonView = () => {
    const [buttonTitle, setButtonTitle] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>();
    const dataRequestsService = useDataRequestsApiContext();
    const { dataRequest, updateDataRequest, setIsUpdatingStatus, isUpdatingStatus } = useDataRequestContext();
    const modalService = useModalApiContext();

    const handleTrackClick = () => {
        setIsLoading(true);
        setIsUpdatingStatus(true);
        dataRequestsService.setTracking(dataRequest.id, !dataRequest.doNotTrack).subscribe((updatedDataRequest) => {
            updateDataRequest(updatedDataRequest);
            setIsLoading(false);
            setIsUpdatingStatus(false);
        }, modalService.error);
    };

    const updateButtonTitle = () => {
        setButtonTitle(dataRequest?.doNotTrack ? 'Track' : 'Do not track');
    };

    useEffect(() => {
        updateButtonTitle();
    }, [dataRequest]);

    return (
        <AdminHeaderButtonView
            dataId={DTISetTrackingButton.TrackButton}
            title={buttonTitle}
            style={{ marginRight: 10 }}
            onClick={handleTrackClick}
            isDisabled={isUpdatingStatus}
            isLoading={isLoading}
        />
    );
};
